import React from 'react';
import PropTypes from 'prop-types';

import { CodeSnippet } from '$partials/global';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ModuleEmbedCode = ({
    code,
}) => {
    return (
        <div className='w-full flex flex-wrap my-30 md:my-60 sm:flex-row-reverse'>
            <div className='w-full sm:w-8/12 md:w-7/12 px-10 sm:px-20 sm:mr-w-2/12 md:mr-w-1/12 module-embed-code'>
                <CodeSnippet html={code} />
            </div>
        </div>
    );

};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

ModuleEmbedCode.propTypes = {
    code: PropTypes.string,
};

export default ModuleEmbedCode;
